import './Footer.css'
import styled from "styled-components";
import React, {useState} from "react";
import {useIntl} from "react-intl";
import {useUserInfo} from "../../lib/hooks/useUserInfo";

interface Props{
}

const Version = styled.a`
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
`

const Footer : React.FC<Props> = (props) => {
    const { formatMessage: f } = useIntl();
    const {userInfo : {roles}} = useUserInfo();

    const defaultFooter = <h3>Eco Petrol Logistics</h3>;

    return  <>
        <div className={'footer'}>
            {defaultFooter}
        </div>
    </>
}

export default Footer
